import { Stack, Typography } from "@mui/material";
import UserAvatar from "@entrilia/shared/components/UserAvatar";
import { convertISODateTime } from "@entrilia/shared/utilities/dateUtils";
import type { MessageDeliveryInfo } from "../../../../../../api/types/documentCollectionTypes";

interface Props {
  deliveryInfo: MessageDeliveryInfo;
  onClick?: React.MouseEventHandler<HTMLDivElement>;
}

const getViewStatusText = (deliveryInfo: MessageDeliveryInfo) => {
  if (deliveryInfo.isRead) {
    return deliveryInfo.readDate ? `Viewed - ${convertISODateTime(deliveryInfo.readDate)}` : "Viewed";
  }

  return "Not viewed";
};

const ContactDeliveryInfo = ({ deliveryInfo, onClick }: Props) => {
  const { recipient } = deliveryInfo;

  return (
    <Stack
      direction="row"
      spacing={1.5}
      onClick={onClick}
      sx={[
        { alignItems: "center" },
        (theme) => ({ cursor: "pointer", "&:hover": { "& .recipientName": { color: theme.palette.primary.main } } }),
      ]}
    >
      <UserAvatar size="medium" userName={recipient.name} />
      <Stack spacing={0.5}>
        <Stack direction="row" spacing={0.5} sx={{ alignItems: "baseline" }}>
          <Typography variant="subtitle2" className="recipientName">
            {recipient.name}&nbsp;
          </Typography>
          {!recipient.isRegistered && (
            <Typography variant="caption" color="error">
              Not registered
            </Typography>
          )}
        </Stack>
        <Typography color="textSecondary">{getViewStatusText(deliveryInfo)}</Typography>
      </Stack>
    </Stack>
  );
};

export default ContactDeliveryInfo;
